import { colors } from '@App/libs/components/ds/theme'
import styled from 'styled-components'

export const Separator = styled.div<{ marginTop?: string }>`
    margin-top: ${(props) => props.marginTop ?? '49px'};
    margin-bottom: 49px;
    border-bottom: 1px solid ${colors.gray.jotaGrayLight};
`
